import React, { memo } from "react";
import { Link } from "react-router-dom";

export const UserList = memo(function UserList({ queryResult }) {
  if (!queryResult || !Array.isArray(queryResult)) {
    return null;
  }

  return (
    <div>
      {queryResult.map((user) => {
        const displayName = user.displayName || user.name;
        const isInactive = user.status === "Inactive";
        return (
          <ul className="list-group" key={user.userId}>
            <li className="list-group-item d-flex align-items-center justify-content-between bg-info-subtle">
              <div className="d-flex align-items-center">
                <section className="px-2 fw-bold">
                  <Link to={`/userdetails/${user.userId}`}>
                    {displayName}
                  </Link>
                </section>
                <section className="px-2 text-muted small">{user.email}</section>
              </div>
              <span className={`badge ${isInactive ? "bg-secondary" : "bg-success"}`}>
                {user.status || "Active"}
              </span>
            </li>
          </ul>
        );
      })}
    </div>
  );
});
